var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBoxContact = function SvgBoxContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.006.75l633.5.5 11 14H.713L13.006.75z",
    fill: "#F3F4F5"
  })));
};
export default SvgBoxContact;